import { render, staticRenderFns } from "./entranceImage.vue?vue&type=template&id=6e72a955&scoped=true"
import script from "./entranceImage.vue?vue&type=script&lang=js"
export * from "./entranceImage.vue?vue&type=script&lang=js"
import style0 from "./entranceImage.vue?vue&type=style&index=0&id=6e72a955&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e72a955",
  null
  
)

export default component.exports